import React from "react";
import PropTypes from "prop-types";
import {
  //PlainText,
  SummaryText,
  TakeawayMessages,
  SkipSection,
  ReagentDragDrop,
  ReagentSelect,
  GelDragDropQuestion,
  MaterialsList,
  FullWidthCard,
  SubHeading,
  Heading,
  QuestionCSCQ,
  QuestionColor,
  //FullWidthImage,
  FullWidthAnimation,
  ProtocolTableActual,
  ProtocolTableIdeal,
  ResultsComparisonGel,
  Video
} from "@learningblocks/exp-components";
import {
  HighlightHTML,
  GlossaryProvider,
  NoteBanner,
  NotebookImage
  //GelDragDropQuestion,
} from "@learningblocks/storybook-components";
import { COMPONENT_TYPE } from "@learningblocks/protocol-constants/lib/Utilities";

import {
  getIndividualGlossaryItem,
  getIndividialDataFromAirtable,
  API_DETAILS,
} from '@learningblocks/exp-constants/lib/Utilities';

export function ContentItems(props) {

  const getGlossaryItem = () =>
    getIndividualGlossaryItem(
      getIndividialDataFromAirtable,
      API_DETAILS.URL,
      API_DETAILS.KEY
    );

  const {onOpenGlossary} = React.useContext(GlossaryProvider.Context);

  const renderByType = (component, key) => {
    switch (component.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return (
          <div style={{lineHeight: 1.5, color: "#333"}}>
            <HighlightHTML
              key={key}
              content={component.text}
              getContentData={getGlossaryItem()}
              openGlossary={onOpenGlossary}
            />
          </div>
        );
      case COMPONENT_TYPE.BANNER:
        return (
          <div style={{marginTop: '24px'}}>
            <NoteBanner
              text={component.banner}
              openGlossary={onOpenGlossary}
              getContentData={getGlossaryItem()}
            />
          </div>
        );
      case COMPONENT_TYPE.REAGENT_DRAG_DROP:
        return <ReagentDragDrop key={key} {...component} />;
      case COMPONENT_TYPE.REAGENT_SELECT:
        return <ReagentSelect
                key={key}
                getGlossaryItem={getGlossaryItem()}
                onOpenGlossary={onOpenGlossary}
                {...component}
              />;
      case COMPONENT_TYPE.RESULT_COMPARISON_GEL:
        return <ResultsComparisonGel key={key} {...component} />;
      case COMPONENT_TYPE.GEL_DRAG_DROP_QUESTION:
        return <GelDragDropQuestion
                key={key}
                getContentData={getGlossaryItem()}
                openGlossary={onOpenGlossary}
                gelTitle={component.title}
                {...component}
              />;
      case COMPONENT_TYPE.MATERIALS_LIST:
        return <MaterialsList key={key} {...component} />;
      case COMPONENT_TYPE.SKIP_SECTION:
        return <SkipSection key={key} {...component} />;
      case COMPONENT_TYPE.SUMMARY_TEXT:
        return <SummaryText key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_ACTUAL:
        return <ProtocolTableActual key={key} {...component} />;
      case COMPONENT_TYPE.PROTOCOL_TABLE_IDEAL:
        return <ProtocolTableIdeal key={key} {...component} />;
      case COMPONENT_TYPE.TAKEAWAY_MESSAGES:
        return <TakeawayMessages key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_IMAGE:
        return (
          <NotebookImage
            key={key}
            className="fullWidthImage-item"
            getGlossaryItem={getGlossaryItem()}
            openGlossary={onOpenGlossary}
            {...component}
          />
        );
      case COMPONENT_TYPE.FULL_WIDTH_ANIMATION:
        return (
          <FullWidthAnimation
            key={key}
            className="fullWidthAnimation-item"
            getGlossaryItem={getGlossaryItem()}
            onOpenGlossary={onOpenGlossary}
            {...component}
          />
        );

    case COMPONENT_TYPE.VIDEO:
      // className="fullWidthAnimation-item"
      return (
        <Video
            key={key}
            getGlossaryItem={getGlossaryItem()}
            onOpenGlossary={onOpenGlossary}
            {...component}
        />
      );
      case COMPONENT_TYPE.SUB_HEADING:
        return <SubHeading key={key} {...component} />;
      case COMPONENT_TYPE.HEADING:
        return <Heading key={key} {...component} />;
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return <FullWidthCard key={key} {...component} />;
      case COMPONENT_TYPE.CSCQ:
      case COMPONENT_TYPE.DDQ:
      case COMPONENT_TYPE.MSCQ:
      case COMPONENT_TYPE.OEQ:
      case COMPONENT_TYPE.NEQ:
      case COMPONENT_TYPE.GROUPED_CSCQ:
        return <QuestionCSCQ
                key={key}
                getGlossaryItem={getGlossaryItem()}
                onOpenGlossary={onOpenGlossary}
                {...component}
              />;
      case COMPONENT_TYPE.DNDQ_COLOR:
      case COMPONENT_TYPE.CSCQ_COLOR:
      case COMPONENT_TYPE.GROUPED_DNDQ:
        return <QuestionColor key={key} {...component} />;
      default:
        return null;
    }
  };
  return props.components.map(renderByType);
}
ContentItems.propTypes = {
  components: PropTypes.array.isRequired,
};
